import { render, staticRenderFns } from "./CoursewareSearchWidget.vue?vue&type=template&id=040d9356&"
import script from "./CoursewareSearchWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareSearchWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports